import React, {memo} from "react"
import {ControlModel} from "../../../types/control"
import {Column} from "../../Column"
import {Widget} from "../../Widget"
import "./index.scss"

type Props = {
    control: ControlModel
    temp: string
}

export const DefaultTemperatureComponent = memo(function DefaultTemperatureComponent({control, temp}: Props) {
    return (
        <Column min={3} max={6}>
            <Widget style={{padding: 0}}>
                <div className="default-temperature-container">
                    <div className="dt-value">
                        <span>
                            {temp}
                            <small>°</small>
                        </span>
                    </div>
                    <div className="dt-text">
                        <span>{control.name}</span>
                    </div>
                </div>
            </Widget>
        </Column>
    )
})
